import { useState, useEffect } from 'react';
import { fetchActivityModalsListByOrganization, fetchCalendarsByOrganisationID } from '../Services/Organisation.service';
const useOrganisationData = (organisationId: string, open: boolean) => {
    const [calendars, setCalendars] = useState<any[]>([]);
    const [widgets, setWidgets] = useState<any[]>([]);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (organisationId !== "") {
            localStorage.setItem("organizationid", organisationId);
            fetchWidgets();
        }
    }, [organisationId]);
    useEffect(() => {
        if (organisationId) {
            fetchCalendars();
        }
    }, [organisationId]);

    useEffect(() => {
        localStorage.removeItem("selectedCategory")
    }, []);
    const fetchCalendars = async () => {
        try {
            setLoading(true)
            const data = await fetchCalendarsByOrganisationID(organisationId);
            if (data.data) {
                setCalendars(data.data);
                setLoading(false)
            }
        } catch (error) {
            console.log(error);
        }
    };
    const fetchWidgets = async () => {
        try {

            const data = await fetchActivityModalsListByOrganization();
            if (data.data) {
                setWidgets(data.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    return { calendars, widgets, fetchCalendars, fetchWidgets, setCalendars, setLoading, loading };

}
export default useOrganisationData;